import { FormInstance } from 'antd';

export const checkIsFormValid = (form: FormInstance, namePath?: string[], isAllTouched?: boolean) => {
  const isFormError = form.getFieldsError().some(({ errors }) => errors.length > 0);
  const isFieldsTouched = form.isFieldsTouched(namePath, isAllTouched);
  return !isFormError && isFieldsTouched;
};
